import { useEffect, useState } from "react";
import { api, GAMES } from "@/lib/api";

export function useGames() {
  const [games, setGames] = useState(GAMES.filter((g) => g !== "Tutti"));
  useEffect(() => {
    api.get("/games").then((r) => setGames(r.data)).catch(() => {});
  }, []);
  return games;
}
